import { useAuthFetchWithResponse } from '@e3dc-react/shell/Hooks/AuthFetch'

import { getDynamicEmsSettings } from '../../api/dynamic-ems.api'
import { DynamicEmsSettingsModel } from '../../types'
import { isUndefined } from 'lodash'
import { usePortalQuery } from 'src/Libs/api'

type ReturnType = {
  data: DynamicEmsSettingsModel | null
  isLoading: boolean
  refetch: () => void
}

/**
 * Shared by every consumer of the dynamic EMS settings query; all of them must cache the unwrapped `DynamicEmsSettingsModel`.
 */
export const getDynamicEmsSettingsQueryKey = (installationId: string | undefined) => ['dynamic-ems-settings', installationId] as const

/**
 * Hook to fetch the dynamic ems (AI360) values
 */
export const useDynamicEms = (installationId: string | undefined, enabled = true): ReturnType => {
  const authFetch = useAuthFetchWithResponse()
  const { data, isLoading, refetch } = usePortalQuery({
    queryKey: getDynamicEmsSettingsQueryKey(installationId),
    queryFn: () => getDynamicEmsSettings(installationId?.toString(), authFetch),
    select: data => data ?? null,
    enabled: enabled && !isUndefined(installationId),
    refetchOnMount: 'always',
  })

  return {
    data: data ?? null,
    isLoading,
    refetch,
  }
}
